import { showFailureToast } from "@helpers";
import { reviewApi } from "@services/api";
import moment from "moment";
import { call, put } from "redux-saga/effects";
import {
  checkUserReviewAction,
  checkUserReviewActions,
  getCourseReviewSummaryAction,
  submitReviewCourseActions,
} from "../slices";

function* submitReviewCourseWorker({ payload }) {
  try {
    yield put(submitReviewCourseActions.pending());
    const newReview = {
      ...payload.review,
      createdAt: moment().subtract(7, "hours"),
    };
    yield put(checkUserReviewActions.updateUserReview(newReview));
    const response = yield call(reviewApi.submitReviewCourse, payload.review);

    // TODO: handle callback | onSuccess
    yield put(submitReviewCourseActions.success(response));
    yield put(getCourseReviewSummaryAction(payload.courseId));
    yield put(checkUserReviewAction(payload.courseId));
  } catch (error) {
    yield put(submitReviewCourseActions.failure(error));
    yield call(
      showFailureToast,
      error?.message || "Review was failed. Retry again!"
    );
    // TODO: handle callback | onFailure
  }
}

export { submitReviewCourseWorker };
